/**
 * Do not edit directly
 * Generated on Thu, 05 Nov 2026 00:37:53 GMT
 */

export const BreakpointSizeSmall = "480px";
export const BreakpointSizeMedium = "768px";
export const BreakpointSizeLarge = "1025px";
export const BreakpointSizeExtraLarge = "2000px";
export const BreakpointQuerySmall = "only screen and (min-width: 480px)";
export const BreakpointQueryMedium = "only screen and (min-width: 768px)";
export const BreakpointQueryLarge = "only screen and (min-width: 1025px)";
export const BreakpointQueryExtraLarge = "only screen and (min-width: 2000px)";
export const MobileQueryLegacyInvertedPattern = "only screen and (max-width: 800px)";
export const ColorNeutral0 = "#ffffff";
export const ColorNeutral100 = "#f4f4f4";
export const ColorNeutral150 = "#efeff2";
export const ColorNeutral200 = "#e0e0e0";
export const ColorNeutral300 = "#c1c1c1";
export const ColorNeutral400 = "#717171";
export const ColorNeutral500 = "#222222";
export const ColorNeutral600 = "#1b1919";
export const ColorNeutral700 = "#000000";
export const ColorNeutralBase = "#222222";
export const ColorTomato500 = "#e94d41";
export const ColorCherry100 = "#fbece9";
export const ColorCherry500 = "#d2451e";
export const ColorCherry600 = "#ba3612";
export const ColorCherry700 = "#a62603";
export const ColorGrapefruit100 = "#fbf1ee";
export const ColorGrapefruit400 = "#f4d8ce";
export const ColorGrapefruit500 = "#edab93";
export const ColorGrapefruit700 = "#794039";
export const ColorPeanutButter100 = "#fdf6ef";
export const ColorPeanutButter400 = "#f4dabb";
export const ColorPeanutButter500 = "#e6a65d";
export const ColorPeanutButter700 = "#51312d";
export const ColorMustard100 = "#f9eed8";
export const ColorMustard500 = "#d69e25";
export const ColorMustard600 = "#ba8206";
export const ColorMustard700 = "#9e6d00";
export const ColorAvocado100 = "#edf4e0";
export const ColorAvocado400 = "#d4e5b6";
export const ColorAvocado500 = "#a6be78";
export const ColorAvocado700 = "#214e33";
export const ColorAvocado800 = "#072713";
export const ColorSpinach100 = "#e6f4e6";
export const ColorSpinach500 = "#438442";
export const ColorSpinach600 = "#2f752e";
export const ColorSpinach700 = "#2b642b";
export const ColorElderberry100 = "#f1f6f9";
export const ColorElderberry400 = "#d6e4ee";
export const ColorElderberry500 = "#93bdda";
export const ColorElderberry700 = "#283a70";
export const ColorBlueberry100 = "#ebeef6";
export const ColorBlueberry500 = "#4b69c4";
export const ColorBlueberry600 = "#3350a8";
export const ColorBlueberry700 = "#1d3a93";
export const ColorFig100 = "#f8f5f8";
export const ColorFig400 = "#eddfed";
export const ColorFig500 = "#d2a7d2";
export const ColorFig700 = "#6b3077";
export const ColorKale100 = "#edf4e0";
export const ColorKale400 = "#214e33";
export const ColorKale500 = "#173724";
export const ColorKale700 = "#0d1f14";
export const ColorConcord100 = "#f7f8f9";
export const ColorConcord500 = "#2c3650";
export const ColorConcord600 = "#141d34";
export const ColorConcord700 = "#0e1628";
export const ColorShadow100 = "#222222";
export const ColorShadow200 = "#222222";
export const ColorShadow300 = "#222222";
export const ColorShadow400 = "#222222";
export const ColorWhite100 = "#ffffff";
export const ColorWhite200 = "#ffffff";
export const ColorWhite300 = "#ffffff";
export const ColorWhite400 = "#ffffff";
export const ColorBlack100 = "#000000";
export const ColorBlack200 = "#000000";
export const ColorBlack300 = "#000000";
export const ColorBlack400 = "#000000";
export const ColorFacebook500 = "#3874ea";
export const ColorFacebook600 = "#2363df";
export const ColorFacebook700 = "#0d4dcc";
export const ColorTwitter500 = "#1d9bf0";
export const ColorTwitter600 = "#0988dd";
export const ColorTwitter700 = "#0073c1";
export const ColorInteractiveLight = "#edf4e0";
export const ColorInteractiveBase = "#214e33";
export const ColorInteractiveDark = "#173724";
export const ColorInteractiveDarker = "#0d1f14";
export const ColorInteractiveMutedBase = "#222222";
export const ColorInteractiveMutedLight = "#e0e0e0";
export const ColorInteractiveMutedDark = "#1b1919";
export const ColorInteractiveMutedDarker = "#000000";
export const ColorSuccessLight = "#e6f4e6";
export const ColorSuccessBase = "#438442";
export const ColorSuccessDark = "#2f752e";
export const ColorSuccessDarker = "#2b642b";
export const ColorWarningLight = "#f9eed8";
export const ColorWarningBase = "#d69e25";
export const ColorWarningDark = "#ba8206";
export const ColorWarningDarker = "#9e6d00";
export const ColorCriticalLight = "#fbece9";
export const ColorCriticalBase = "#d2451e";
export const ColorCriticalDark = "#ba3612";
export const ColorCriticalDarker = "#a62603";
export const ColorBackgroundBase = "#ffffff";
export const ColorBackgroundTinted = "#f4f4f4";
export const ColorLinePrimary = "#222222";
export const ColorLineSecondary = "#e0e0e0";
export const ColorLineTertiary = "#f4f4f4";
export const ColorLinePrimaryInverted = "#f4f4f4";
export const ColorLineSecondaryInverted = "#ffffff";
export const ColorTextPrimaryInverted = "#ffffff";
export const ColorAccentsBrand = "#e94d41";
export const ColorAccentsGrapefruitLighter = "#fbf1ee";
export const ColorAccentsGrapefruitLight = "#f4d8ce";
export const ColorAccentsGrapefruitBase = "#edab93";
export const ColorAccentsGrapefruitDark = "#794039";
export const ColorAccentsPeanutButterLighter = "#fdf6ef";
export const ColorAccentsPeanutButterLight = "#f4dabb";
export const ColorAccentsPeanutButterBase = "#e6a65d";
export const ColorAccentsPeanutButterDark = "#51312d";
export const ColorAccentsAvocadoLighter = "#edf4e0";
export const ColorAccentsAvocadoLight = "#d4e5b6";
export const ColorAccentsAvocadoBase = "#a6be78";
export const ColorAccentsAvocadoDark = "#214e33";
export const ColorAccentsAvocadoDarker = "#072713";
export const ColorAccentsElderberryLighter = "#f1f6f9";
export const ColorAccentsElderberryLight = "#d6e4ee";
export const ColorAccentsElderberryBase = "#93bdda";
export const ColorAccentsElderberryDark = "#283a70";
export const ColorAccentsFigLighter = "#f8f5f8";
export const ColorAccentsFigLight = "#eddfed";
export const ColorAccentsFigBase = "#d2a7d2";
export const ColorAccentsFigDark = "#6b3077";
export const ColorElementPrimary = "#222222";
export const ColorElementSecondary = "#717171";
export const ColorElementPrimaryInverted = "#ffffff";
export const ColorElementSecondaryInverted = "#ffffff";
export const ColorThirdPartyFacebookBase = "#3874ea";
export const ColorThirdPartyFacebookDark = "#2363df";
export const ColorThirdPartyFacebookDarker = "#0d4dcc";
export const ColorThirdPartyTwitterBase = "#1d9bf0";
export const ColorThirdPartyTwitterDark = "#0988dd";
export const ColorThirdPartyTwitterDarker = "#0073c1";
export const ColorDisabledBase = "#c1c1c1";
export const ColorDimensionShadowLevelOne = "#222222";
export const ColorDimensionShadowLevelTwo = "#222222";
export const ColorDimensionShadowLevelThree = "#222222";
export const ColorDimensionShadowLevelFour = "#222222";
export const ColorDimensionBorderLevelOne = "#222222";
export const ColorDimensionBorderLevelTwo = "#222222";
export const ColorDimensionBorderLevelThree = "#222222";
export const ColorDimensionBorderLevelFour = "#222222";
export const ColorTintBase = "#ffffff";
export const ColorTintDark = "#ffffff";
export const ColorTintDarker = "#ffffff";
export const ColorShadeBase = "#000000";
export const ColorShadeDark = "#000000";
export const ColorShadeDarker = "#000000";
export const ColorHoverBase = "#f4f4f4";
export const ColorPressedBase = "#efeff2";
export const ColorSelectedBase = "#222222";
export const ColorFocusBase = "#2c3650";
export const ShadowLevelOne = {"x":0,"y":1,"blur":4,"spread":0};
export const ShadowLevelTwo = {"x":0,"y":1,"blur":8,"spread":0};
export const ShadowLevelThree = {"x":0,"y":1,"blur":12,"spread":0};
export const ShadowLevelFour = {"x":0,"y":1,"blur":12,"spread":0};
export const ShadowBorderLevelOne = {"x":0,"y":0,"blur":0,"spread":1};
export const ShadowBorderLevelTwo = {"x":0,"y":0,"blur":0,"spread":1};
export const ShadowBorderLevelThree = {"x":0,"y":0,"blur":0,"spread":1};
export const ShadowBorderLevelFour = {"x":0,"y":0,"blur":0,"spread":1};
export const DimensionLevelOneShadowDimensions = {"x":0,"y":1,"blur":4,"spread":0};
export const DimensionLevelOneShadowColor = "#222222";
export const DimensionLevelOneBorderDimensions = {"x":0,"y":0,"blur":0,"spread":1};
export const DimensionLevelOneBorderColor = "#222222";
export const DimensionLevelOneZAxisDepth = 1;
export const DimensionLevelTwoShadowDimensions = {"x":0,"y":1,"blur":8,"spread":0};
export const DimensionLevelTwoShadowColor = "#222222";
export const DimensionLevelTwoBorderDimensions = {"x":0,"y":0,"blur":0,"spread":1};
export const DimensionLevelTwoBorderColor = "#222222";
export const DimensionLevelTwoZAxisDepth = 2;
export const DimensionLevelThreeShadowDimensions = {"x":0,"y":1,"blur":12,"spread":0};
export const DimensionLevelThreeShadowColor = "#222222";
export const DimensionLevelThreeBorderDimensions = {"x":0,"y":0,"blur":0,"spread":1};
export const DimensionLevelThreeBorderColor = "#222222";
export const DimensionLevelThreeZAxisDepth = 3;
export const DimensionLevelFourShadowDimensions = {"x":0,"y":1,"blur":12,"spread":0};
export const DimensionLevelFourShadowColor = "#222222";
export const DimensionLevelFourBorderDimensions = {"x":0,"y":0,"blur":0,"spread":1};
export const DimensionLevelFourBorderColor = "#222222";
export const DimensionLevelFourZAxisDepth = 4;
export const ZIndex0 = 0;
export const ZIndex1 = 1;
export const ZIndex2 = 2;
export const ZIndex3 = 3;
export const ZIndex4 = 4;
export const ZIndex300 = 300;
export const ZIndex500 = 500;
export const ModalZIndex = 300;
export const ZendeskChatZIndexOverride = 999999;
export const GradientBackgroundGreenToWhiteGradient = "linear-gradient(180deg, rgba(212, 229, 182, 0.60) 0%, rgba(244, 244, 244, 0.00) 100%)";
export const GradientBackgroundProgressiveOnboarding = "linear-gradient(180deg, #fbf6ee 0%, #fff 100%)";
export const LayoutSpace0 = "0";
export const LayoutSpace1 = "4";
export const LayoutSpace2 = "8";
export const LayoutSpace3 = "12";
export const LayoutSpace4 = "16";
export const LayoutSpace5 = "20";
export const LayoutSpace6 = "24";
export const LayoutSpace8 = "32";
export const LayoutSpace10 = "40";
export const LayoutSpace12 = "48";
export const LayoutSpace16 = "64";
export const LayoutSpace20 = "80";
export const LayoutSpace250 = "1000";
export const LayoutSpace05 = "2";
export const LayoutGridGutter1 = "16";
export const LayoutGridGutter2 = "24";
export const LayoutPageMargin1 = "16";
export const LayoutPageMargin2 = "32";
export const LayoutPageMargin3 = "80";
export const LayoutGridColumns12 = "repeat(12, minmax(0, 1fr))";
export const ComponentInsetSquare1 = "4";
export const ComponentInsetSquare2 = "8";
export const ComponentInsetSquare3 = "12";
export const ComponentInsetSquare4 = "16";
export const ComponentInsetSquare6 = "24";
export const ComponentInsetSquare8 = "32";
export const ComponentInsetSquish1 = "2 4";
export const ComponentInsetSquish2 = "4 8";
export const ComponentInsetSquish3 = "8 12";
export const ComponentInsetSquish4 = "12 16";
export const ComponentInsetSquish6 = "16 24";
export const PageInsetMobile2 = "8 16";
export const PageInsetMobile3 = "12 16";
export const PageInsetMobile6 = "24 16";
export const PageInsetMobile8 = "32 16";
export const PageInsetMobile12 = "48 16";
export const PageInsetTabletDesktop2 = "8 32";
export const PageInsetTabletDesktop3 = "16 32";
export const PageInsetTabletDesktop6 = "32 32";
export const PageInsetTabletDesktop8 = "48 32";
export const PageInsetTabletDesktop12 = "64 32";
export const Stack0 = "0";
export const Stack1 = "4";
export const Stack2 = "8";
export const Stack3 = "12";
export const Stack4 = "16";
export const Stack6 = "24";
export const Stack8 = "32";
export const Stack10 = "40";
export const Stack250 = "1000";
export const Stack05 = "2";
export const StackX0 = "0";
export const StackX1 = "4";
export const StackX2 = "8";
export const StackX3 = "12";
export const StackX4 = "16";
export const StackX6 = "24";
export const StackX8 = "32";
export const StackX10 = "40";
export const StackX05 = "2";
export const StackY0 = "0";
export const StackY1 = "4";
export const StackY2 = "8";
export const StackY3 = "12";
export const StackY4 = "16";
export const StackY6 = "24";
export const StackY8 = "32";
export const StackY10 = "40";
export const StackY05 = "2";
export const SizeDimensionBorderRadiusCircle = "999";
export const FontFamilyBase = "ABCReproVariable";
export const FontFamilySerif = "VCHoney";
export const FontFamilySansSerif = "ABCReproVariable";
export const StyleTextItalics = "italics";
export const StyleTextNormal = "normal";
export const StyleTextBase = "italics";
export const SizeText5 = "0.71rem";
export const SizeText10 = "0.85rem";
export const SizeText20 = "1rem";
export const SizeText30 = "1.07rem";
export const SizeText40 = "1.15rem";
export const SizeText50 = "1.25rem";
export const SizeText60 = "1.3rem";
export const SizeText70 = "1.35rem";
export const SizeText80 = "1.45rem";
export const SizeText90 = "1.5rem";
export const SizeText100 = "1.75rem";
export const SizeText110 = "1.85rem";
export const SizeText120 = "2.3rem";
export const SizeText130 = "3.5rem";
export const SizeTextBase = "1rem";
export const SizeTextInput = "16rem";
export const WeightTextBook = 400;
export const WeightTextRegular = 350;
export const WeightTextNormal = 400;
export const WeightTextMedium = 500;
export const WeightTextHeavy = 550;
export const LineHeightText10 = "14px";
export const LineHeightText20 = "16px";
export const LineHeightText25 = "18px";
export const LineHeightText30 = "20px";
export const LineHeightText40 = "21px";
export const LineHeightText50 = "22px";
export const LineHeightText60 = "24px";
export const LineHeightText70 = "25px";
export const LineHeightText80 = "28px";
export const LineHeightText90 = "32px";
export const LineHeightText100 = "40px";
export const LineHeightText110 = "60px";
export const LetterSpacingText0 = "0.00px";
export const LetterSpacingText10 = "0.20px";
export const LetterSpacingText20 = "0.25px";
export const LetterSpacingText30 = "0.30px";
export const LetterSpacingText50 = "0.50px";
export const LetterSpacingText80 = "0.80px";
export const LetterSpacingTextBase = "0.20px";
export const ParagraphSpacing10 = "8px";
export const ParagraphSpacing20 = "10px";
export const HeroFontFamily = "VCHoney";
export const HeroSizeTextLarge = "3.5rem";
export const HeroSizeTextSmall = "2.3rem";
export const HeroWeightText = 400;
export const HeroLineHeightTextLarge = "60px";
export const HeroLineHeightTextSmall = "40px";
export const HeroLetterSpacingText = "0.30px";
export const HeroAltFontFamily = "ABCReproVariable";
export const HeroAltSizeTextLarge = "3.5rem";
export const HeroAltSizeTextSmall = "2.3rem";
export const HeroAltWeightText = 550;
export const HeroAltLineHeightTextLarge = "60px";
export const HeroAltLineHeightTextSmall = "40px";
export const HeroAltLetterSpacingTextLarge = "0.00px";
export const HeroAltLetterSpacingTextSmall = "0.00px";
export const H1FontFamily = "VCHoney";
export const H1SizeTextLarge = "2.3rem";
export const H1SizeTextSmall = "1.85rem";
export const H1WeightText = 550;
export const H1LineHeightTextLarge = "40px";
export const H1LineHeightTextSmall = "32px";
export const H1LetterSpacingText = "0.00px";
export const H1AltFontFamily = "ABCReproVariable";
export const H1AltSizeTextLarge = "2.3rem";
export const H1AltSizeTextSmall = "1.85rem";
export const H1AltWeightText = 550;
export const H1AltLineHeightTextLarge = "40px";
export const H1AltLineHeightTextSmall = "32px";
export const H1AltLetterSpacingText = "0.00px";
export const H2FontFamily = "ABCReproVariable";
export const H2SizeTextLarge = "1.75rem";
export const H2SizeTextSmall = "1.45rem";
export const H2WeightText = 550;
export const H2LineHeightTextLarge = "32px";
export const H2LineHeightTextSmall = "25px";
export const H2LetterSpacingText = "0.00px";
export const H3FontFamily = "ABCReproVariable";
export const H3SizeTextLarge = "1.5rem";
export const H3SizeTextSmall = "1.25rem";
export const H3WeightText = 550;
export const H3LineHeightTextLarge = "28px";
export const H3LineHeightTextSmall = "24px";
export const H3LetterSpacingText = "0.00px";
export const H4FontFamily = "ABCReproVariable";
export const H4SizeTextLarge = "1.3rem";
export const H4SizeTextSmall = "1.15rem";
export const H4WeightText = 550;
export const H4LineHeightTextLarge = "25px";
export const H4LineHeightTextSmall = "22px";
export const H4LetterSpacingText = "0.00px";
export const H5FontFamily = "ABCReproVariable";
export const H5SizeTextLarge = "1.15rem";
export const H5SizeTextSmall = "1.07rem";
export const H5WeightText = 550;
export const H5LineHeightTextLarge = "22px";
export const H5LineHeightTextSmall = "21px";
export const H5LetterSpacingText = "0.00px";
export const H6FontFamily = "ABCReproVariable";
export const H6SizeTextLarge = "1rem";
export const H6SizeTextSmall = "1rem";
export const H6WeightText = 550;
export const H6LineHeightTextLarge = "20px";
export const H6LineHeightTextSmall = "20px";
export const H6LetterSpacingText = "0.00px";
export const H7FontFamily = "ABCReproVariable";
export const H7SizeTextLarge = "0.85rem";
export const H7SizeTextSmall = "0.85rem";
export const H7WeightText = 550;
export const H7LineHeightTextLarge = "18px";
export const H7LineHeightTextSmall = "18px";
export const H7LetterSpacingText = "0.00px";
export const LeadFontFamily = "ABCReproVariable";
export const LeadSizeTextLarge = "1.3rem";
export const LeadSizeTextSmall = "1.15rem";
export const LeadWeightText = 350;
export const LeadLineHeightTextLarge = "25px";
export const LeadLineHeightTextSmall = "22px";
export const LeadLetterSpacingText = "0.00px";
export const BodySizeTextLarge = "1rem";
export const BodySizeTextSmall = "1rem";
export const BodyFontFamily = "ABCReproVariable";
export const BodyWeightText = 350;
export const BodyLineHeightTextLarge = "20px";
export const BodyLineHeightTextSmall = "20px";
export const BodyLetterSpacingText = "0.00px";
export const CaptionH7WeightText = 550;
export const CaptionBaseLetterSpacingText = "0.00px";
export const CaptionBaseWeightText = 400;
export const CaptionBaseFontFamily = "ABCReproVariable";
export const CaptionBaseSizeTextLarge = "0.85rem";
export const CaptionBaseSizeTextSmall = "0.85rem";
export const CaptionBaseLineHeightTextLarge = "18px";
export const CaptionBaseLineHeightTextSmall = "18px";
export const CaptionXtraSmallLetterSpacingText = "0.00px";
export const CaptionXtraSmallWeightText = 400;
export const CaptionXtraSmallFontFamily = "ABCReproVariable";
export const CaptionXtraSmallSizeTextLarge = "0.71rem";
export const CaptionXtraSmallSizeTextSmall = "0.71rem";
export const CaptionXtraSmallLineHeightTextLarge = "14px";
export const CaptionXtraSmallLineHeightTextSmall = "14px";
